export enum OutboundFaxStatus {
  pendingScheduling = 'pending_scheduling',
  scheduled = 'scheduled',
  skipped = 'skipped',
  queued = 'queued',
  sent = 'sent',
  failed = 'failed',
  canceled = 'canceled',
}
